import type * as lazyIndex from './lazyIndex';
import { LazyAction, LazyModule } from 'owa-bundling';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "SuggestedUnsubscribe"*/ './lazyIndex'),
    { name: 'SuggestedUnsubscribe' }
);

// Init/Fetching
export const lazyCreateSuggestedUnsubscribeItems: LazyAction<
    typeof lazyIndex.createSuggestedUnsubscribeItems,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.createSuggestedUnsubscribeItems);

// Lazy actions
export const lazyRemoveSuggestedUnsubscribeItem: LazyAction<
    typeof lazyIndex.removeSuggestedUnsubscribeItem,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.removeSuggestedUnsubscribeItem);

export const lazyUpdateSuggestedUnsubscribeAllowList: LazyAction<
    typeof lazyIndex.updateSuggestedUnsubscribeAllowList,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.updateSuggestedUnsubscribeAllowList);

// Types
export type { default as SuggestedUnsubscribeItem } from './store/schema/SuggestedUnsubscribeItem';

// Selectors
export { default as getSuggestedUnsubscribeItem } from './selectors/getSuggestedUnsubscribeItem';
export { default as isSuggestedUnsubscribeItem } from './selectors/isSuggestedUnsubscribeItem';

// Utils
export { default as getSuggestedUnsubscribeReasonString } from './utils/getSuggestedUnsubscribeReasonString';
